module.exports = "<div *ngIf=\"active\">\n  <div class=\"signal\"></div>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/Templates/spinner.html
// module id = ./src/app/Templates/spinner.html
// module chunks = main